import React, { useState, useEffect } from 'react';
import { ActivityEntry } from '../../types/user';
import { fetchHistory } from '../../services/profileService';

export default function History() {
  const [history, setHistory] = useState<ActivityEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchHistory()
      .then(setHistory)
      .catch((err: any) => setError(err.message || 'Failed to load history'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = history.filter(h =>
    h.description.toLowerCase().includes(search.toLowerCase()) ||
    h.type.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="profile-section">
      <div className="profile-section-header">
        <h3 className="profile-section-title">Account History</h3>
        <input
          type="text"
          className="auth-input"
          placeholder="Search activity…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ maxWidth: 260 }}
        />
      </div>

      {loading && <div className="profile-loading">Loading history…</div>}
      {error && <div className="profile-error">{error}</div>}
      {!loading && !error && filtered.length === 0 && (
        <p className="profile-empty">No activity found.</p>
      )}
      {filtered.length > 0 && (
        <table className="profile-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Description</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(h => (
              <tr key={h.id}>
                <td>{h.type}</td>
                <td>{h.description}</td>
                <td>{h.amount != null ? `$${h.amount.toFixed(2)}` : '—'}</td>
                <td><span className={`status-badge status-${h.status}`}>{h.status}</span></td>
                <td>{new Date(h.date).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
